import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import {mapGetters} from 'vuex';

type ToastPosition = 'top-right' | 'top-center' | 'top-left' | 'bottom-right' | 'bottom-center' | 'bottom-left';

@Component({
  computed: {
    ...mapGetters({
      userLanguage: 'getUserLanguage',
      enableTicketShop: 'getEnableTicketShop',
    }),
  },
})
export class BaseMixin extends Vue {
  userLanguage!: string;
  enableTicketShop!: boolean;
  isResize: boolean = false;

  protected isRequesting: boolean = false;

  get isMobile() {
    if (this.isResize) {
      // trigger update of computed prop
    }
    return window.innerWidth <= 768;
  }

  setResize() {
    this.isResize = true;
    Vue.nextTick(() => this.isResize = false);
  }

  get hasUserLanguage(): boolean {
    return this.userLanguage.length > 0;
  }

  protected showToast(message: string, duration: number = 5000, position: ToastPosition = 'bottom-right') {
    this.$toasted.show(message, {position, duration});
  }

  protected showInfoToast(message: string, duration: number = 5000, position: ToastPosition = 'bottom-right') {
    this.$toasted.info(message, {position, duration});
  }

  protected showErrorToast(message: string, duration: number = 5000, position: ToastPosition = 'bottom-right') {
    this.$toasted.error(message, {position, duration});
  }
}
